import type { PastClient } from '../types/activity'

export const pastClients: PastClient[] = [
  {
    id: 'PC-201',
    name: 'The Hollands',
    closedLabel: 'Closed Mar 2023',
    program: 'Conventional 30yr',
    rate: '6.375%',
    quarterlyTouchLabel: 'Yesterday',
    quarterlyTouchDaysAgo: 1,
    planningCallDue: false,
    escrowAnalysisDue: true,
    equityNote: 'Est. $84k equity gain since closing',
    phone: '(612) 555-0311',
    email: 'holland.family@example.com',
  },
  {
    id: 'PC-202',
    name: 'Marcus & Dana Webb',
    closedLabel: 'Closed Aug 2022',
    program: 'FHA 30yr',
    rate: '5.875%',
    quarterlyTouchLabel: '4 months ago',
    quarterlyTouchDaysAgo: 122,
    planningCallDue: true,
    escrowAnalysisDue: false,
    equityNote: 'MI removal likely eligible',
    phone: '(612) 555-0322',
    email: 'webb.household@example.com',
  },
  {
    id: 'PC-203',
    name: 'Elena Ruiz',
    closedLabel: 'Closed Jan 2024',
    program: 'Conventional 30yr',
    rate: '7.125%',
    quarterlyTouchLabel: '5 months ago',
    quarterlyTouchDaysAgo: 151,
    planningCallDue: true,
    escrowAnalysisDue: true,
    equityNote: 'Strong refinance candidate if rates hold',
    phone: '(612) 555-0333',
    email: 'elena.ruiz@example.com',
  },
  {
    id: 'PC-204',
    name: 'The Okonkwos',
    closedLabel: 'Closed Jun 2021',
    program: 'VA 30yr',
    rate: '3.250%',
    quarterlyTouchLabel: '6 weeks ago',
    quarterlyTouchDaysAgo: 44,
    planningCallDue: false,
    escrowAnalysisDue: false,
    equityNote: 'Asked about a second home last spring',
    phone: '(612) 555-0344',
    email: 'okonkwo.family@example.com',
  },
  {
    id: 'PC-205',
    name: 'Brett Sandoval',
    closedLabel: 'Closed Oct 2023',
    program: 'Jumbo 7/6 ARM',
    rate: '6.750%',
    quarterlyTouchLabel: null,
    quarterlyTouchDaysAgo: null,
    planningCallDue: true,
    escrowAnalysisDue: false,
    equityNote: 'No touch logged since closing',
    phone: '(612) 555-0355',
    email: 'brett.sandoval@example.com',
  },
  {
    id: 'PC-206',
    name: 'Yuki & Tom Barrow',
    closedLabel: 'Closed Feb 2023',
    program: 'Conventional 15yr',
    rate: '5.500%',
    quarterlyTouchLabel: '2 weeks ago',
    quarterlyTouchDaysAgo: 15,
    planningCallDue: false,
    escrowAnalysisDue: true,
    equityNote: 'Tax reassessment raised their payment $118/mo',
    phone: '(612) 555-0366',
    email: 'barrow.house@example.com',
  },
]

export function pastClientDueState(client: PastClient): {
  label: string
  classes: string
  overdue: boolean
} {
  if (client.quarterlyTouchDaysAgo === null) {
    return {
      label: 'Never touched',
      classes: 'bg-danger-50 text-danger-700 ring-danger-200',
      overdue: true,
    }
  }
  if (client.quarterlyTouchDaysAgo > 90) {
    return {
      label: 'Quarterly touch overdue',
      classes: 'bg-danger-50 text-danger-700 ring-danger-200',
      overdue: true,
    }
  }
  if (client.quarterlyTouchDaysAgo > 60) {
    return {
      label: 'Due this month',
      classes: 'bg-warn-50 text-warn-700 ring-warn-200',
      overdue: false,
    }
  }
  return {
    label: 'Current',
    classes: 'bg-success-50 text-success-700 ring-success-200',
    overdue: false,
  }
}
